//Components
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
gsap.registerPlugin( ScrollTrigger, DrawSVGPlugin);


import "../scss/theme.scss";
import "./components/sticky-header.js";
import "./components/anchor-scroll.js";
import "./components/mobile-menu.js";
import "./components/carousels.js";
import "./components/match-height.js";
import "./components/we-connect.js";
import "./components/process-line.js";

import "./components/material-forms.js";



window.addEventListener(
	"DOMContentLoaded",
	function () {
		//SVG INJECTOR
		const elementsToInject = document.querySelectorAll(".inject-me");
		const injectorOptions = {
			evalScripts: "once",
		};
		let injector = new SVGInjector(injectorOptions);
		if (elementsToInject.length) {
			injector.inject(elementsToInject);
		}
	},
	false
);
